import { createFileRoute } from "@tanstack/react-router";
import { Section, SectionHeader, PageHero } from "@/components/site-blocks";
import { TEAM_MEMBERS } from "@/content/team";
import { PersonCard } from "@/components/team/person-card";
import { TeamContactForm } from "@/components/team/team-contact-form";
import { pageSeo } from "@/lib/seo";
import teamHero from "@/assets/team/team-hero.jpg.asset.json";

export const Route = createFileRoute("/the-team")({
  head: () => ({
    ...pageSeo({
      path: "/the-team",
      title: "Meet the Team | CRS Energy",
      description:
        "Surveyors, installers, retrofit specialists, heating engineers and support staff. Meet the people behind CRS Energy.",
    }),
  }),
  component: TheTeamPage,
});

function scrollToContact(e: React.MouseEvent<HTMLAnchorElement>) {
  e.preventDefault();
  const el = document.getElementById("contact-team");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

function TheTeamPage() {
  return (
    <>
      <PageHero
        eyebrow="Meet the Team"
        title="Meet the CRS Energy Team"
        description="The people behind your survey, installation, customer care and aftercare. From first enquiry to completion, our in-house team helps keep every job clear, compliant and properly managed."
        image={teamHero.url}
        imageAlt="CRS Energy team in front of branded vans"
        objectPosition="center 25%"
      />

      <div className="bg-secondary/40 border-b">
        <div className="container-page py-6 flex flex-wrap items-center justify-between gap-3">
          <p className="text-sm text-muted-foreground">
            Prefer to speak to a specific team member? Use the Contact button on any card.
          </p>
          <a
            href="#contact-team"
            onClick={scrollToContact}
            className="inline-flex items-center rounded-full bg-accent text-accent-foreground px-5 py-2.5 text-sm font-semibold shadow-cta hover:bg-accent/90 transition-colors"
          >
            Get in Touch
          </a>
        </div>
      </div>

      <Section id="team">
        <div className="grid gap-6 grid-cols-1">
          {TEAM_MEMBERS.map((m) => (
            <PersonCard key={m.name} member={m} />
          ))}
        </div>
      </Section>

      <Section id="contact-team" className="bg-secondary/40">
        <div className="max-w-3xl mx-auto">
          <SectionHeader
            title="Get in Touch"
            description="Send us a message and we'll route it to the right person. If you used a Contact button above, we've pre-selected that team member."
            align="center"
          />
          <TeamContactForm />
        </div>
      </Section>
    </>
  );
}
